import React, { useState } from 'react';
import { Compass, Briefcase, GraduationCap, Home, CheckCircle2 } from 'lucide-react';

export const TransitionMatrixModule: React.FC = () => {
  const [selectedGoal, setSelectedGoal] = useState('Vocational Culinary Arts Apprenticeship');

  const careers = [
    { title: 'Vocational Culinary Arts Apprenticeship', category: 'Hospitality', skill: 'Food Prep & Kitchen Safety' },
    { title: 'Digital Document Digitization Specialist', category: 'Office IT', skill: 'Scanning & Data Ingestion' },
    { title: 'Greenhouse & Horticultural Assistant', category: 'Agriculture', skill: 'Plant Care & Inventory' }
  ];

  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-indigo-500/20 text-indigo-300 text-xs font-bold rounded-full border border-indigo-500/30">
            <Compass className="w-3.5 h-3.5" /> Module 30: Secondary Transition & Vocational Matrix (Ages 14-22)
          </div>
          <h2 className="text-2xl font-black mt-2">IDEA Sec 300.320 Post-Secondary Goal Synthesis</h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {careers.map((c, idx) => (
          <div 
            key={idx} 
            onClick={() => setSelectedGoal(c.title)}
            className={`p-5 rounded-2xl border transition cursor-pointer space-y-3 ${
              selectedGoal === c.title ? 'bg-indigo-900/40 border-indigo-500 ring-2 ring-indigo-400' : 'bg-slate-950 border-slate-800 hover:border-slate-700'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-extrabold px-2 py-0.5 bg-indigo-500/20 text-indigo-300 rounded uppercase">{c.category}</span>
              {selectedGoal === c.title && <CheckCircle2 className="w-4 h-4 text-emerald-400" />}
            </div>
            <h3 className="font-bold text-sm text-slate-100">{c.title}</h3>
            <p className="text-xs text-slate-400">Key Skill: {c.skill}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
